import { Clock, Code2, Layers, Zap } from 'lucide-react';

const reasons = [
  {
    icon: Clock,
    value: '6+',
    label: 'Years Experience',
    description: 'Building digital products for startups and enterprises since 2018.',
  },
  {
    icon: Layers,
    value: '∞',
    label: 'Scalable Architecture',
    description: 'Systems designed to grow with your business, handling millions of users.',
  },
  {
    icon: Zap,
    value: '2x',
    label: 'Fast Delivery',
    description: 'Agile methodology ensuring rapid iterations and timely releases.',
  },
  {
    icon: Code2,
    value: '100%',
    label: 'Clean Code',
    description: 'Maintainable, well-documented code following industry best practices.',
  },
];

const WhyUs = () => {
  return (
    <section 
      id="why-us" 
      className="relative py-24 md:py-32 overflow-hidden"
      data-testid="why-us-section"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-slate-900/50 to-slate-950" />
      
      {/* Decorative elements */}
      <div className="absolute top-1/2 left-0 w-1/2 h-px bg-gradient-to-r from-transparent via-blue-500/20 to-transparent" />
      <div className="absolute top-1/2 right-0 w-1/2 h-px bg-gradient-to-r from-transparent via-indigo-500/20 to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-slate-800 bg-slate-900/50 text-sm text-blue-400 mb-4">
            Why Broadway Tech
          </span>
          <h2 
            className="font-space text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-4"
            data-testid="why-us-title"
          >
            Why Choose Us
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto text-base md:text-lg">
            We combine technical excellence with a deep understanding of business needs
          </p>
        </div>

        {/* Reasons Grid */}
        <div 
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
          data-testid="why-us-grid"
        >
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="group relative text-center p-8 rounded-2xl bg-slate-900/30 border border-slate-800 hover:border-blue-500/30 transition-all duration-300"
              data-testid={`why-us-card-${index}`}
            >
              {/* Icon */}
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-blue-500/10 border border-blue-500/20 mb-6 group-hover:bg-blue-500/20 transition-colors">
                <reason.icon className="w-6 h-6 text-blue-400" />
              </div>

              {/* Value */}
              <div className="font-space text-4xl md:text-5xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">
                {reason.value}
              </div>

              {/* Label */}
              <div className="text-lg font-semibold text-white mb-3">
                {reason.label}
              </div>

              {/* Description */}
              <p className="text-sm text-slate-500 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
